import { Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const DangerZone: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const actions = useContext(ctx.actions);
  const [remove, setRemove] = useState<string>('');

  const {
    teams: { currentTeam },
  } = useContext(ctx.store);

  const handleRemove = async () => {
    await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
    const response = currentTeam.teamId
      ? await ((actions.teams.deactivateTeam(currentTeam.teamId) as unknown) as Promise<IStore>)
      : await ((actions.tenants.deactivateTenant(
          currentTeam.tenantId
        ) as unknown) as Promise<IStore>);
    if (!response.teams.currentTeam || !response.tenants.currentTenant) {
      history.push('/home');
    }
  };

  return (
    <Grid container>
      <Grid className={classes.metricGridItemsFull} item xs={12}>
        <Paper className={clsx(classes.paper, classes.metricBoxChart)}>
          <Grid className={classes.sides}>
            <Typography component="h2" className={classes.subtitle}>
              Delete Workspace
            </Typography>
            <Typography component="h2" className={classes.text}>
              {`Danger Zone: When you click the button below, you will deactivate this workspace from Sensla.`}
            </Typography>
          </Grid>
          <Grid className={classes.sides}>
            <Typography component="h2" className={classes.text}>
              {`To remove your workspace write "DELETE ${currentTeam.name.toUpperCase()}" and press the button.`}
            </Typography>
            <TextField
              margin="normal"
              fullWidth
              data-validators="isRequired, isEmail"
              onChange={(event: any) => setRemove(event.target.value)}
            />
            <Button
              disabled={
                remove !== `DELETE ${currentTeam.name.toUpperCase()}` ||
                remove !== `BORRAR ${currentTeam.name.toUpperCase()}`
              }
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleRemove}
            >
              Delete Workspace
            </Button>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export { DangerZone };
